import styled from "@emotion/styled";

const PageHeading = styled.h1`
  font-weight: 900;
`;

PageHeading.displayName = "PageHeading";

export default PageHeading;
